import { RematchDispatch } from '@rematch/core';
import { IRootModel } from 'app/store';
import { EModalKey } from 'entities/Modal/Modal.enum';

export const modalEffects = (dispatch: RematchDispatch<IRootModel>) => ({
  showInactivityModal() {
    dispatch.modal.hideModal(EModalKey.TimeEditor);
    dispatch.modal.hideModal(EModalKey.Complete);
    dispatch.modal.hideModal(EModalKey.Escalate);
    dispatch.modal.showModal(EModalKey.Inactivity);
  },
});
